"use strict";
/**
 * APITable <https://github.com/apitable/apitable>
 * Copyright (C) 2022 APITable Ltd. <https://apitable.com>
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as published by
 * the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.TrackEvents = void 0;
var TrackEvents;
(function (TrackEvents) {
    TrackEvents["ButtonClick"] = "ButtonClick";
    TrackEvents["OpTransform"] = "OpTransform";
    TrackEvents["Operation"] = "Operation";
    TrackEvents["OldLocalChangeset"] = "OldLocalChangeset";
    TrackEvents["UpdateLog"] = "UpdateLog";
    TrackEvents["ViewsInfo"] = "ViewsInfo";
    TrackEvents["IntroVideoStart"] = "IntroVideoStart";
    TrackEvents["IntroVideoEnd"] = "IntroVideoEnd";
    // Folder novice guide related
    TrackEvents["TaskListPush"] = "TaskListPush";
    TrackEvents["TaskListClick"] = "TaskListClick";
    TrackEvents["TaskListComplete"] = "TaskListComplete";
    TrackEvents["TaskListClose"] = "TaskListClose";
    TrackEvents["Theme"] = "Theme";
    TrackEvents["Language"] = "Language";
    TrackEvents["RecordCard"] = "RecordCard";
    // Template center search keyword report
    TrackEvents["TemplateKeyword"] = "TemplateKeyword";
    // posthug event name
    TrackEvents["TemplateSearchKeyword"] = "templateSearchKeyword";
    TrackEvents["TemplatePageView"] = "templatePageView";
    TrackEvents["TemplateUse"] = "templateUse";
    TrackEvents["TemplateConfirmUse"] = "templateConfirmUse";
    TrackEvents["InviteByContacts"] = "inviteByContacts";
    TrackEvents["InviteByWorkbench"] = "inviteByWorkbench";
})(TrackEvents = exports.TrackEvents || (exports.TrackEvents = {}));
//# sourceMappingURL=track_events.js.map